export default __webpack_public_path__ + "static/media/051-compass.f89183f8.svg";